/**
 * @generated SignedSource<<70526601205ead6c4f693db2da637796>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerOnelineMenuContainerQuery$variables = {
  topicQueueName?: string | null | undefined;
};
export type headerOnelineMenuContainerQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"headerAllMenuQuery" | "headerOnelineMenuAppConfigQuery" | "headerOnelineMenuStyleQuery">;
};
export type headerOnelineMenuContainerQuery = {
  response: headerOnelineMenuContainerQuery$data;
  variables: headerOnelineMenuContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topicQueueName"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v9 = [
  (v5/*: any*/),
  (v1/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v9/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "articleTypes",
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": (v9/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sponsorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PaywallType",
      "kind": "LinkedField",
      "name": "paywallTypes",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegment",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": (v9/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "type": "Base",
  "abstractKey": "__isBase"
},
v14 = [
  (v1/*: any*/)
],
v15 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Article",
  "abstractKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Gallery",
  "abstractKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Podcast",
  "abstractKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Recipe",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Video",
  "abstractKey": null
},
v21 = [
  (v4/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "type": "Base",
    "abstractKey": "__isBase"
  }
],
v22 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "Topic",
  "abstractKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v22/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v21/*: any*/),
            "type": "Section",
            "abstractKey": null
          },
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "headerOnelineMenuContainerQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "headerOnelineMenuAppConfigQuery"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "headerOnelineMenuStyleQuery"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "headerAllMenuQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "headerOnelineMenuContainerQuery",
    "selections": [
      {
        "alias": "onelineMenu",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "scmp_pwa_oneline_menu"
            }
          }
        ],
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_oneline_menu\"})"
      },
      {
        "alias": "styleOnelineMenu",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "scmp_pwa_oneline_menu_style"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v13/*: any*/)
                        ],
                        "type": "Section",
                        "abstractKey": null
                      },
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:6)"
          },
          (v1/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"scmp_pwa_oneline_menu_style\"})"
      },
      {
        "alias": "columnistsQueue",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "scmp_columnists"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 7
              }
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "types",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "type": "AUTHOR_IMAGE"
                                }
                              }
                            ],
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "118x118"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "style(filter:{\"style\":\"118x118\"})"
                              }
                            ],
                            "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
                          },
                          (v13/*: any*/)
                        ],
                        "type": "Author",
                        "abstractKey": null
                      },
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:7)"
          },
          (v1/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"scmp_columnists\"})"
      },
      {
        "alias": "focusQueue",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "all_menu_focus"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 2
              }
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": "items(first:2)"
          },
          (v1/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"all_menu_focus\"})"
      },
      {
        "alias": "highlightsQueue",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "all_menu_highlights"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 4
              }
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": "items(first:4)"
          },
          (v1/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"all_menu_highlights\"})"
      },
      {
        "alias": "topicQueue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "topicQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v22/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:6)"
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "61f7b1f1996beac7cef4c09bcd48ef5d",
    "id": null,
    "metadata": {},
    "name": "headerOnelineMenuContainerQuery",
    "operationKind": "query",
    "text": "query headerOnelineMenuContainerQuery(\n  $topicQueueName: String\n) {\n  ...headerOnelineMenuAppConfigQuery\n  ...headerOnelineMenuStyleQuery\n  ...headerAllMenuQuery\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  name\n  types\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"118x118\"}) {\n      url\n    }\n  }\n}\n\nfragment entityLink on Base {\n  __isBase: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersAppBarAdStatusBase\n}\n\nfragment headerAllMenuColumnistsQuery on Query {\n  columnistsQueue: queue(filter: {name: \"scmp_columnists\"}) {\n    items(first: 7) {\n      edges {\n        node {\n          __typename\n          ... on Author {\n            ...entityLink\n            ...authorAvatarAuthor\n            name\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Article {\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment headerAllMenuFocusQuery on Query {\n  focusQueue: queue(filter: {name: \"all_menu_focus\"}) {\n    items(first: 2) {\n      edges {\n        node {\n          __typename\n          ... on Topic {\n            ...entityLink\n            name\n          }\n          ... on Section {\n            ...entityLink\n            name\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Article {\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment headerAllMenuHighlightsQuery on Query {\n  highlightsQueue: queue(filter: {name: \"all_menu_highlights\"}) {\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Topic {\n            ...entityLink\n            name\n          }\n          ... on Section {\n            ...entityLink\n            name\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Article {\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment headerAllMenuQuery on Query {\n  ...headerAllMenuColumnistsQuery\n  ...headerAllMenuFocusQuery\n  ...headerAllMenuHighlightsQuery\n  ...headerAllMenuSectionAppConfigQuery\n  ...headerAllMenuTopicsQuery\n}\n\nfragment headerAllMenuSectionAppConfigQuery on Query {\n  onelineMenu: appConfig(filter: {entityId: \"scmp_pwa_oneline_menu\"}) {\n    json\n    id\n  }\n}\n\nfragment headerAllMenuTopicsQuery on Query {\n  topicQueue: queue(filter: {name: $topicQueueName}) {\n    items(first: 6) {\n      edges {\n        node {\n          __typename\n          ... on Topic {\n            ...entityLink\n            name\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Article {\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment headerOnelineMenuAppConfigQuery on Query {\n  onelineMenu: appConfig(filter: {entityId: \"scmp_pwa_oneline_menu\"}) {\n    json\n    id\n  }\n}\n\nfragment headerOnelineMenuStyleQuery on Query {\n  styleOnelineMenu: queue(filter: {name: \"scmp_pwa_oneline_menu_style\"}) {\n    items(first: 6) {\n      edges {\n        node {\n          __typename\n          ... on Section {\n            ...entityLink\n            ...sectionStyleHeaderMenuItem\n            name\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Article {\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment helpersAppBarAdStatusBase on Base {\n  __isBase: __typename\n  ... on Section {\n    __typename\n    ...helpersStyleSectionContent\n  }\n}\n\nfragment helpersAppBarVariantBase on Base {\n  __isBase: __typename\n  ...helpersCheckIsLongReadArticle\n  ...helpersCheckIsMorningStudioArticle\n  ...helpersCheckIsPhotoEssayArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsPostiesArticle\n  ...helpersCheckIsPostiesPage\n  ...helpersCheckIsStyleArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on Base {\n  __isBase: __typename\n  ...helpersCheckIsPostiesArticle\n  ...helpersCheckIsPostiesPage\n}\n\nfragment helpersCheckIsLongReadArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsMorningStudioArticle on Article {\n  sponsorType\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPhotoEssayArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Article {\n  paywallTypes {\n    entityUuid\n    id\n  }\n}\n\nfragment helpersCheckIsPostiesArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPostiesPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsStyleArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment sectionStyleHeaderMenuItem on Section {\n  name\n  entityId\n}\n"
  }
};
})();

(node as any).hash = "b3dd998cb9f36e96d4e11dafe7b53725";

export default node;
